export const language = process.env.GATSBY_LEGAL_LANGUAGE
export const PARTNER_SHORT_NAME = process.env.GATSBY_LEGAL_PARTNER_SHORT_NAME
export const PARTNER_COMPANY_NAME =
  process.env.GATSBY_LEGAL_PARTNER_COMPANY_NAME
export const PARTNER_VAT = process.env.GATSBY_LEGAL_PARTNER_VAT
export const PARTNER_ADDRESS_AND_HOUSE_NUMBER =
  process.env.GATSBY_LEGAL_PARTNER_ADDRESS_AND_HOUSE_NUMBER
export const PARTNER_POST_CODE = process.env.GATSBY_LEGAL_PARTNER_POST_CODE
export const PARTNER_CITY = process.env.GATSBY_LEGAL_PARTNER_CITY
export const PARTNER_SUPPORT_EMAIL =
  process.env.GATSBY_LEGAL_PARTNER_SUPPORT_EMAIL
export const PARTNER_DATA_PROCESSORS =
  process.env.GATSBY_LEGAL_PARTNER_DATA_PROCESSORS
export const PARTNER_PARTNERS = process.env.GATSBY_LEGAL_PARTNER_PARTNERS
export const LEGAL_VERSION_TERMS = process.env.GATSBY_LEGAL_TERMS_VERSION
export const LEGAL_LAST_UPDATED_TERMS =
  process.env.GATSBY_LEGAL_TERMS_LAST_UPDATED
export const LEGAL_VERSION_PRIVACY = process.env.GATSBY_PRIVACY_TERMS_VERSION
export const LEGAL_LAST_UPDATED_PRIVACY =
  process.env.GATSBY_PRIVACY_TERMS_LAST_UPDATED
export const LEGAL_VERSION_MARKETING =
  process.env.GATSBY_MARKETING_TERMS_VERSION
export const LEGAL_LAST_UPDATED_MARKETING =
  process.env.GATSBY_MARKETING_TERMS_LAST_UPDATED
const vatString = language === "da" ? "CVR nr." : "VAT no."
export const LEGAL_CONTACT_INFO = `${PARTNER_COMPANY_NAME}\n${vatString} ${PARTNER_VAT}\n${PARTNER_ADDRESS_AND_HOUSE_NUMBER}\n${PARTNER_POST_CODE} ${PARTNER_CITY}\n${PARTNER_SUPPORT_EMAIL}`

export const concatBundleToString = (bundle: string | undefined) => {
  let processorString = ""
  if (!bundle) {
    return processorString
  }
  const processors = bundle.split("::")
  for (let i = 0; i < processors.length; i++) {
    processorString += `${processors[i]}\n\n`
  }
  return processorString
}
